// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delay1{animation-delay:.5s;-webkit-animation-delay:.5s;-moz-animation-delay:.5s;-o-animation-delay:.5s}.delay2{animation-delay:1.5s;-webkit-animation-delay:1.5s;-moz-animation-delay:1.5s;-o-animation-delay:1.5s}", ""]);
// Exports
module.exports = exports;
